import {
  ECompatibilityReportType,
  IApiCompatibilityReportLight,
  IApiMemberProfile,
  IRawApiCompatibilityReport,
} from 'affiny-core/modules/api/models/member/member.types';
import { IMemberChoices } from 'affiny-core/modules/api/models/memberchoice/memberchoice.types';
import { IApiMultiplePictureResponse } from 'affiny-core/modules/api/models/picture/picture.types';
import { AffinyEndpoint } from '../affinyEndpoints/affiny.endpoints';

export const MembersResource = {
  getMemberChoicesByAccountId: async (
    accountId: string
  ): Promise<IMemberChoices> => {
    const response = await AffinyEndpoint.Member.url(`/${accountId}/profile/`)
      .get()
      .json();

    return response.data.attributes;
  },
  postHiddenProfile: (accountId: string) =>
    AffinyEndpoint.Member.url(`/${accountId}/profile/hidden/`).post().res(),

  getMemberByAccountId: (accountId: string, includes: string[] = []) =>
    AffinyEndpoint.Member.url(`/${accountId}/`)
      .query(includes.length ? `include=${includes.join(',')}` : '')
      .get()
      .json<IApiMemberProfile>(),

  postReflistChoices: (accountId: string, memberChoices: IMemberChoices) =>
    AffinyEndpoint.Member.url(`/${accountId}/profile/`)
      .post({
        data: { type: 'memberchoice', attributes: { fields: memberChoices } },
      })
      .res(),

  updateAnnounce: (announce: string) =>
    AffinyEndpoint.Announce.url(`/selfportrait/`)
      .patch({
        data: { type: 'memberchoice', attributes: { text: announce } },
      })
      .res(),

  getPictures: (accountId: string) =>
    AffinyEndpoint.MemberPictures.url(`/${accountId}/pictures/`)
      .get()
      .json<IApiMultiplePictureResponse>(),

  getCompatibilityReportLight: (myAboid: string, otherAboid: string) =>
    AffinyEndpoint.CompatibilityReport.url(`/${myAboid}/light/${otherAboid}`)
      .get()
      .json<IApiCompatibilityReportLight>(),

  getCompatibilityReport: (
    myAboid: string,
    reportType: ECompatibilityReportType,
    otherAboid: string
  ) =>
    AffinyEndpoint.CompatibilityReport.url(
      `/${myAboid}/${reportType}/${otherAboid}`
    )
      .get()
      .json<IRawApiCompatibilityReport>(),
};
